import React, { useState } from "react";
import { Editor } from "@monaco-editor/react";

const RunCodeEditor = ({template, setTemplate}) => {
  const [code, setCode] = useState(null);

  const handleEditorChange = (value) => {
    setCode(value);
    setTemplate({ ...template, code:value });
  };

  console.log(template);

  const handleRunCode = () => {
    // Example for running JavaScript code
    try {
      // eslint-disable-next-line no-eval
      console.log(code);
      eval(code);
    } catch (error) {
      console.error("Error in your code:", error);
    }
  };

  return (
    // <div style={{ height: "100%", display: "flex" }}>
      <div style={{border: "1px solid #ddd", borderRadius: 8   }}>
        <Editor
          height="500px"
          defaultLanguage="javascript"
          // theme="vs-dark"
          value={template?.code}
          onChange={(value) => handleEditorChange(value)}
          options={{
            fontSize: 14,
            minimap: { enabled: false },
            automaticLayout: true,
          }}
        />
      {/* </div> */}

      {/* <button
        style={{
          padding: "10px 20px",
          marginTop: 10,
          backgroundColor: "#007BFF",
          color: "#fff",
          border: "none",
          borderRadius: 5,
          cursor: "pointer",
        }}
        onClick={handleRunCode}
      >
        Run Code
      </button> */}
    </div>
  );
};

export default RunCodeEditor;
